import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import DeleteIcon from '@material-ui/icons/BackspaceSharp';
import AddIcon from '@material-ui/icons/AddSharp';

const useStyles = makeStyles((theme) => ({
  tag: {
    height: '20px',
    minWidth: '0px',
    padding: theme.spacing(0.5),
  },
  label: {
    fontSize: '0.85em',
    color: '#303031',
    whiteSpace: 'nowrap',
  },
  count: {
    fontSize: '0.8em',
    color: '#999',
  },
  clickable: {
    cursor: 'pointer',
  },
  user: {
    backgroundColor: '#ddeeff',
  },
  auto: {
    backgroundColor: '#ebeeee',
  },
  specialAdd: {
    backgroundColor: '#ddeeff',
  },
  iconButton: {
    height: '20px',
    width: '20px',
  },
  icon: {
    height: '14px',
    width: '14px',
  },
}));

export default function Tag(props) {
  const classes = useStyles();
  const { label, count, tagType, showButtons, onClick, onDelete } = props;

  return (<>
    {((tagType != 'specialAdd') || showButtons) && (
      <span
        className={`${classes.tag} ${classes[tagType]} ${onClick && classes.clickable}`}
        color='primary'
        size='small'
        onClick={() => (onClick && (tagType != 'specialAdd') && onClick(label))}
      >
        <span className={classes.label}>
          {label}
        </span>
        {count && (
          <span className={classes.count}>
            {` [${count}]`}
          </span>
        )}
        {showButtons && onDelete && (tagType == 'user') && (
          <Tooltip title='Remove tag'>
            <IconButton
              size='small'
              className={classes.iconButton}
              onClick={onDelete}
            >
              <DeleteIcon className={classes.icon} />
            </IconButton>
          </Tooltip>
        )}
        {showButtons && (tagType == 'specialAdd') && (
          <Tooltip title='Add tag'>
            <IconButton
              size='small'
              className={classes.iconButton}
              onClick={onClick}
            >
              <AddIcon className={classes.icon} />
            </IconButton>
          </Tooltip>
        )}
      </span>
    )}
  </>);
}
